export const namespace = 'canalplus.block.geolocation';
export { default as Component } from './containers/ModalGeolocationContainer';
export { default as propsFormatter } from './propsFormatter';
